import styled from 'styled-components';

import Table from 'xpi-black-ui/Common/Table';
import { Label } from 'xpi-black-ui/Base/Checkbox/styles';

export default styled(Table)`
  ${Label} {
      & > div {
      top: -6px;
    }
  }

  td, th {
    padding: 0 7px;
  }

  .disabled {
    cursor: not-allowed;

    &:before {
      cursor: not-allowed;
      color: #5d5d5d;
    }
  }

  .status-tooltip {
    border: 0;
  }

  .status-name {
    max-width: 125px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: red;
  }
`;

export const SomaTableCellDiv = styled.div`
  soma-table-cell.soma-table-cell.hydrated {
    color: #a6a7a8;
  }

  .soma-table-row {
    border-bottom: none;
  }

  .ListItemEven .soma-table-row.soma-table-row.soma-table-row-uncollapsable.default.hydrated {
    background-color: #47494f;
    border-bottom: none;
  }

  .ListItemOdd .soma-table-row.soma-table-row.soma-table-row-uncollapsable.default.hydrated {
    background-color: #3f4147;
    border-bottom: none;
  }

`;
